import React, { useState } from 'react';
import { useField } from 'formik';
import Loader from 'features/Loader/Loader';

import FileUpload from './FileUpload';

export default function ProgressPhotoField({
  label,
  urlFieldName,
  sizeFieldName,
  addToFilesToBeDeleted
}) {
  const [field, meta] = useField(urlFieldName);
  const [uploading, setUploading] = useState(false);

  if (uploading) {
    return (
      <div className="photos-list-block">
        <Loader />
      </div>
    );
  } else {
    return (
      <div id={urlFieldName} className="photos-list-block">
        <h5>{label}</h5>
        {field.value ? (
          <PhotoField
            imageURL={field.value}
            urlFieldName={urlFieldName}
            sizeFieldName={sizeFieldName}
            uploading={uploading}
            setUploading={setUploading}
            addToFilesToBeDeleted={addToFilesToBeDeleted}
          />
        ) : (
          <UploadPhotoField
            urlFieldName={urlFieldName}
            sizeFieldName={sizeFieldName}
            btn={NewPhotoBtn}
            uploading={uploading}
            setUploading={setUploading}
            addToFilesToBeDeleted={addToFilesToBeDeleted}
          />
        )}
        {meta.touched && meta.error && (
          <div className="input-feedback">{meta.error}</div>
        )}
      </div>
    );
  }
}

function UploadPhotoField({
  urlFieldName,
  sizeFieldName,
  btn,
  setUploading,
  addToFilesToBeDeleted
}) {
  return (
    <FileUpload
      urlFieldName={urlFieldName}
      sizeFieldName={sizeFieldName}
      accept="image/*"
      setUploading={setUploading}
      maxSize={30}
      maxSizeError="Max size of the image is 30mega"
    >
      {onClick => btn(onClick, urlFieldName, addToFilesToBeDeleted)}
    </FileUpload>
  );
}

function PhotoField({
  imageURL,
  urlFieldName,
  sizeFieldName,
  uploading,
  setUploading,
  addToFilesToBeDeleted
}) {
  return (
    <div className="uploaded-photo">
      <img src={imageURL} alt="Progress" />
      <UploadPhotoField
        urlFieldName={urlFieldName}
        sizeFieldName={sizeFieldName}
        btn={RetakePhotoBtn}
        uploading={uploading}
        setUploading={setUploading}
        addToFilesToBeDeleted={addToFilesToBeDeleted}
      />
    </div>
  );
}

function NewPhotoBtn(onClick) {
  return (
    <button type="button" className="btn btn-greyishBrown" onClick={onClick}>
      <i className="fas fa-plus"></i>
      Upload Photo
    </button>
  );
}

function RetakePhotoBtn(onClick, fieldName, addToFilesToBeDeleted) {
  const [field, ,] = useField(fieldName);

  return (
    <button
      type="button"
      className="btn btn-gray"
      onClick={() => {
        addToFilesToBeDeleted(field.value);
        onClick();
      }}
    >
      <i className="fas fa-sync-alt"></i>
    </button>
  );
}
